(function ($) {
  $('.js-apply-last-filter-btn').one('click', async e => {
    const { product } = e.currentTarget.dataset;
    const data = await Thor.Filter.show({ product });
    const { filter } = data;
    const queryString = $.param(filter);

    UserTracker.emit('event', {
      eventName: 'questions search shortcut used'
    });

    Turbolinks.visit(`${window.location.pathname}?${queryString}`);
  });
})(jQuery);
